/*================================================================================================================
 MAIN CONTROLLER
 ================================================================================================================*/
angular
  .module('vppApp')
  .controller('MainController', MainController);

MainController.$inject = ['$scope', '$rootScope', '$window', '$http', '$timeout', 'vppConfig', 'BreakPointService', '$location', 'VarientService', 'SetLiveSwapService', 'ProgramInfoService', 'ThirdPartyMessages', 'AuthenticationService', '$document', 'IdMePopUp'];

function MainController($scope, $rootScope, $window, $http, $timeout, vppConfig, BreakPointService, $location, VarientService, SetLiveSwapService, ProgramInfoService, ThirdPartyMessages, AuthenticationService, $document, IdMePopUp) {

  var liveswapImg = '';
  var LSBrand = SetLiveSwapService.getLSBrandName();
  var varient;
  var vn = getParameterByName('vn');
  if (vn === 'soty') vn = null; // Disable SOTY
  var routePath = $location.path().toLowerCase();
  var GCPath = vppConfig.globalConnectSignIn[environment];
  var chatEnabledSites = vppConfig.chatEnabledSites;
  $scope.thisYear = vppConfig.reusableValues.currentYear;
  $scope.theSite = "VPP";


  $scope.idMePopUp = IdMePopUp;


  $scope.status = 'ready';
  $rootScope.siteCode = vppConfig.folderPath;
  $rootScope.shortSiteName = vppConfig.shortSiteNames[$rootScope.siteCode];
  $rootScope.altSiteName = vppConfig.altSiteNames[$rootScope.siteCode];
  $scope.siteName = vppConfig.siteNames.siteCode;
  $scope.contentSliderImagePath = vppConfig.contentSliderImagePath;
  $rootScope.isAuth = false;
  BreakPointService.SetBreakPoint();
  $rootScope.history = [];
  $scope.popupTemplate = "";
  $scope.show = false;
  $scope.modalShown = false;
  if (domainAbbr === 'ded') {
    $scope.gcLogin = GCPath + '/samljunction/samlsso?app=ded';
  }


  $scope.isAuthenticated = function (){
    return AuthenticationService.isAuthenticated();
  };


  // chatNow enablement
  $timeout(function(){
    if (chatEnabledSites.indexOf($rootScope.siteCode) !== -1 && !$scope.isAuthenticated()) {
      $rootScope.chatEnabled = true;
    } else {
      $rootScope.chatEnabled = false;
    }
  })

  if (!varient && vn) {
    //getting variables from url for soty
    varient = vn;
    // sets the above variable in local storage to be used again
    VarientService.addVarient(varient);
  } else if (!varient && routePath) {
    varient = routePath.split('/')[2];
    if(varient === 'soty'){
      // varient = "soty";
      varient = null;
    } else {
      varient = null;
    }
    VarientService.addVarient(varient);
  }
  if (!LSBrand) {
    //getting variables liveswap
    LSBrand = getParameterByName('tierExp');
    //sets the above variable in local storage to be used again
    SetLiveSwapService.addLSBrand(LSBrand);
  }
  if (LSBrand) {
    var liveswap = SetLiveSwapService.getLSBrandName();
    liveswapImg = vppConfig.lsImage[liveswap];
    $scope.logoPath = vppConfig.logoPath + liveswapImg + '.png';
  } else {
    $scope.logoPath = vppConfig.logoPath + '.png';
  }

  // on state change, check if new state is in states array
  // if true, check $rootScope.programData
  // if that's undefined, null, or empty, redirect users to the view-auth state
  $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
    var states = [
      '/obtainauth/',
      '/program-overview/',
      '/vehicle-search/', // currently disabled
      '/vehicle-tag-detail/', // currently disabled
      '/vehicle-tag-success/', // currently disabled
      '/get-authorization-number/',
      '/get-authorization-number/step-2/',
      '/get-authorization-number/complete/'
    ];
    var url = toState.url;
    var inStates = states.indexOf(url);

    if (inStates > -1) {
      // var programData = $rootScope.programData;
      var programData = ProgramInfoService.getProgramInf();

      // if program data is undefined, null, or empty, redirect to the view-auth state
      if(typeof programData === 'undefined' || programData === null || angular.equals(programData, {})) {
        $state.go("view-auth");
      }
    }
  });
  $scope.toggleModal = function (val, data) {
    $scope.modalShown = !$scope.modalShown;
    $scope.popupTemplate = vppConfig.modalPaths[val];
    $scope.popupTemplateData = data;
    $scope.popupTemplateConfig = vppConfig;
    if ($scope.modalShown === true) {
      document.getElementsByTagName('body')[0].style['overflow'] = "hidden";
    } else {
      document.getElementsByTagName('body')[0].style['overflow'] = "auto";
    }
  };

  $scope.hideModalCallback = function (val) {
    $scope.modalShown = false;
    document.getElementsByTagName('body')[0].style['overflow'] = "auto";
  };
  $scope.$broadcast('assignTemplateEvent', $scope.popupTemplate);
  $scope.$broadcast('assignTemplateEvent', $scope.popupTemplateConfig);

  $scope.goBack = function () {
    var prevUrl = $scope.history.length > 1 ? $scope.history.splice(-2)[0] : "/";
    $location.path(prevUrl);
  };

  if($location.$$search['ssoError'] && $location.path() === '/'){
    // show a modal if EMP and user not verified, else use the ThirdPartyMessages service.
    if($scope.siteCode === 'emp' && $location.$$search['message'] === 'notVerified') {
      $document.ready(function() {
        $scope.toggleModal('ssoEmpNotVerified');
      });
    } else {
      ThirdPartyMessages.setMessage(($location.$$search['message'] || 'ssoPageFailed'), 'error');
    }
  }

  /*
  Redirects that aren't covered with properties files
  */
  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    // console.log('event', event);
    // console.log('toState', toState);
    // console.log('toParams', toParams);
    // console.log('fromState', fromState);
    // console.log('fromParams', fromParams);

    // redirect FF videos links to /share/
    if($scope.siteCode === 'emp' && toState.url == '/videos/') {
      // strip "email" URL param from URL
      $location.search('email', null);
      // redirect to share page
      $location.path('share');
    }
  })

}
